import { Component, OnInit, OnDestroy, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng2-bootstrap';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { Router } from '@angular/router';
import { FormlyFieldConfig } from 'ng-formly';
import { evalExpression } from 'ng-formly/src/core/utils';
import { LoopBackFilter, Entity, Entityfield, Entityrecord } from '../../../sdk/models';
import { EntityApi, EntityfieldApi, EntityrecordApi } from '../../../sdk/services/custom';
import { LoopBackAuth } from '../../../sdk/services/core/auth.service';
import * as _ from 'lodash';
import { ValidationService } from '../../../services/validation.service';
import { PlatformApp } from '../../../services/app.service';
import { NotificationsService } from 'angular2-notifications';
import 'rxjs/add/operator/takeUntil';

@Component({
    selector: 'entity-add-button',
    templateUrl: './entity-add-button.component.html',
    providers: [EntityrecordApi, EntityApi],
    styleUrls: ['./entity-add-button.component.scss']

})

export class EntityAddButtonComponent implements OnInit, OnDestroy {
    @Input() entityid: string;
    @Input() parentId: string;
    @Input() buttontext: string;
    @Input() gotodetailpage: string;
    @Input() showIconOnly: string = "false";

    @Output() onChanged: EventEmitter<Entityrecord> = new EventEmitter(true);

    subscriptions: any = [];
    filter: LoopBackFilter = <LoopBackFilter>{};
    currentuser: any;
    entity: Entity = new Entity();
    entityDataFields: Array<Entityfield> = [];
    entityFormFields: Array<FormlyFieldConfig> = [];
    appid: any;
    loadText = 'Loading';

    // Form Related
    initialFormData: any;
    formErrors = [];
    // formValid = true;
    get formValid(): boolean { return this.form['formValidity'] == true; }
    get iconOnly(): boolean { return (this.showIconOnly == "true"); }
    quickFilter = '';
    formOptions: any = {};
    model = {};
    form: FormGroup;
    formEntityFields: any = [];
    formEntityRecord: Entityrecord = new Entityrecord();

    @ViewChild('newModal') public newModal: ModalDirective;
    @ViewChild('loadingModal') public loadingModal: ModalDirective;
    notifyOptions = PlatformApp.getNotificationOptions();

    constructor(private fb: FormBuilder, private router: Router, private _EntityApi: EntityApi, private _EntityfieldApi: EntityfieldApi,
        private _EntityrecordApi: EntityrecordApi,
        private _NotificationsService: NotificationsService, private _LoopBackAuth: LoopBackAuth) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({});
        this.form['subscriptions'] = [];
        this.form['formValidity'] = true;
        this.currentuser = this._LoopBackAuth.getCurrentUserData();
        this.appid = this.currentuser.appId;
        PlatformApp.setAppVariable("referenceAppId", this.appid);
        this.refreshData();
    }

    refreshData(): void {
        if (this.entityid)
            this.subscriptions.push(this._EntityApi.getEntityDetails(this.entityid)
                .subscribe((response) => {
                    if (response) {
                        this.entity = _.cloneDeep(response['entity']);
                        this.entityFormFields = response['formfields'];
                        this.entityDataFields = response['datafields'];
                        if (!this.buttontext)
                            this.buttontext = "New " + this.entity.label;
                    }
                }, (err: any) => {
                    console.log(err);
                    this.notify('error', 'ERROR !!!', 'Check Console for Error');
                }));
    }

    public showNewModal(): void {
        this.hideNewModal();
        this.loadingModal.hide();
        this.loadingModal.show();
        this.formEntityRecord = new Entityrecord();
        if (this.parentId)
            this.formEntityRecord['parentId'] = this.parentId;
        this.formEntityFields = _.cloneDeep(this.entityFormFields);
        this.form['viewMode'] = false;
        this.newModal.show();
        this.loadingModal.hide();
    }

    public hideNewModal(): void {
        this.newModal.hide();
        if (this.form) {
            if (this.form['subscriptions']) this.form['subscriptions'].forEach(s => { s.unsubscribe(); });
            this.form = this.fb.group({});
            this.form['subscriptions'] = [];
            this.form['formValidity'] = true;
        }
    }

    ngOnDestroy() {
        for (var i = 0; i < this.subscriptions.length; i++) this.subscriptions[i].unsubscribe();
    }

    submitRecord(entityRecord): void {
        this.formErrors = [];
        this.model = entityRecord;

        this.validateFields(this.formEntityFields);
        this.setFormErrors(this.formErrors);

        this.subscriptions.push(this._EntityfieldApi.validateRecord(this.entityid, entityRecord)
            .subscribe((result) => {
                if (result && result.response && result.response.length > 0) {
                    this.form['formValidity'] = false;
                    this.setFormErrors(result.response);
                }
                if (this.form['formValidity'])
                    this.patchOrCreateEntity(entityRecord);
            }));
    }

    validateFields(formfields) {
        for (var index = 0; index < formfields.length; index++) {
            var field = formfields[index];
            if (field.fieldGroup && field.fieldGroup.length > 0) {
                this.validateFields(field.fieldGroup);
            } else {
                if (field.expressionProperties && field.expressionProperties['templateOptions.required'])
                    if (evalExpression(field.expressionProperties['templateOptions.required'].expression, this, [this.model]))
                        if (!this.model[field.key])
                            this.formErrors.push({ 'field': field.key, 'error': 'required' });

            }
        }
    }
    setFormErrors(formErrors) {
        for (let i = 0; i < formErrors.length; i++) {
            let errorField = formErrors[i].field;
            let errorKey = formErrors[i].error;
            let error = {};
            error[errorKey] = true;
            this.form['formValidity'] = false;
            if (this.form.controls[errorField]) {
                this.form.controls[errorField].markAsTouched();
                this.form.controls[errorField].setErrors(error);
            }
        }
    }

    patchOrCreateEntity(entityRecord): void {
        this.hideNewModal();
        // Save or Create Entity Record
        let entityRecordforSave = new Entityrecord();
        entityRecordforSave.data = entityRecord;
        entityRecordforSave.lastupdatedby = this.currentuser.id;

        //Hack to remove the appId;
        delete entityRecordforSave.data.appId;

        //Hack to update Date and Time in UI TimeZone.
        for (let i = 0; i < this.entityDataFields.length; i++) {
            if (this.entityDataFields[i].fieldtype === 'date' || this.entityDataFields[i].fieldtype === 'datetime') {
                let dateStr = PlatformApp.stringToDate(entityRecordforSave.data[this.entityDataFields[i].name], null, null);
                if (dateStr)
                    entityRecordforSave.data[this.entityDataFields[i].name] = dateStr;
            }
        }

        entityRecordforSave.entityId = this.entity.id;
        entityRecordforSave.createdby = this.currentuser.id;
        entityRecordforSave.appId = this.appid;

        this.subscriptions.push(this._EntityrecordApi.patchOrCreate(entityRecordforSave)
            .subscribe((newrecord: Entityrecord) => {
                this.loadingModal.hide();
                let label = newrecord.id;
                if (newrecord.data && newrecord.data[this.entity['record_name']]) {
                    label = newrecord.data[this.entity['record_name']];
                } else if (newrecord.data & newrecord.data.uniqueId) {
                    label = newrecord.data.uniqueId;
                } else if (newrecord.data & newrecord.data.name) {
                    label = newrecord.data.name;
                }
                this.notify('success', 'Created ' + this.entity.label, label);
                if (this.gotodetailpage && this.gotodetailpage === "true") {
                    this.router.navigate(['/detail/' + newrecord.entityId + '/' + newrecord.id]);
                }

            }));
    }

    public updateValidations(formfields) {
        for (let i = 0; i < formfields.length; i++) {
            let formField = formfields[i];
            let fieldType = formField.type;
            let fieldSubType = '';
            let validators = [];

            if (formField.templateOptions.type) {
                fieldSubType = formField.templateOptions.type;
            } else {
                fieldSubType = 'text';
            }

            switch (fieldType) {
                case 'input-field':
                    switch (fieldSubType) {
                        case 'email':
                            validators.push(ValidationService.emailValidator);
                            break;
                        case 'phone':
                            validators.push(ValidationService.phoneValidator);
                            break;
                        case 'default':
                            break;
                    }
                    break;
                case 'geolocation':
                    validators.push(ValidationService.geolocationValidator);
                    break;
                case 'default':
                    break;
            }
            formField['validators'] = { validation: Validators.compose(validators) };

            if (this.parentId && formField.key === 'parentId') {
                formField.templateOptions.disabled = true;
            }
        }
        return formfields;
    }

    setRecord(record: Entityrecord) {
        this.onChanged.emit(record);
    }

    notify(type, title?, content?, options?) {
        if (!options) options = PlatformApp.getNotificationOptions();
        if (!options.id) options.id = type + '-' + title + '_' + content;
        switch (type) {
            case 'success': this._NotificationsService.success(title, content, options); break;
            case 'alert': this._NotificationsService.alert(title, content, options); break;
            case 'error': this._NotificationsService.error(title, content, options); break;
            case 'info': this._NotificationsService.info(title, content, options); break;
            case 'bare': this._NotificationsService.bare(title, content, options); break;
            default: this._NotificationsService.info(title, content, options);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/widgets/entity-add-button/entity-add-button.component.ts